import * as React from 'react'
import * as LabelPrimitive from '@radix-ui/react-label'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'
import { FieldContext } from './Field'

const labelVariants = cva(
  'block text-left text-sm text-txt-primary data-[large]:text-base font-medium',
)
// text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70
const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof labelVariants> & { large?: boolean }
>(({ className, htmlFor: _htmlFor, large, ...props }, ref) => {
  const context = React.useContext(FieldContext)
  const htmlFor = _htmlFor ?? context?.fieldId
  const largeFromContext = large ?? context?.large

  return (
    <LabelPrimitive.Root
      data-slot="label"
      ref={ref}
      className={cn(labelVariants(), className)}
      htmlFor={htmlFor}
      data-large={largeFromContext ? '' : undefined}
      {...props}
    />
  )
})
Label.displayName = LabelPrimitive.Root.displayName

export { Label }
